import React from "react";
import { Box } from "@sproutsocial/seeds-react-box";
import ContentBlockHybrid from "./ContentBlockHybrid";

export interface ContentBlockBaseProps {
  title: string;
  subtitle?: string;
  titleAs?: "h1" | "h2" | "h3" | "h4";
  subtitleAs?: "h2" | "h3" | "h4" | "h5" | "p";
  isLoading?: boolean;
  children: React.ReactNode;
  headerActions?: React.ReactNode;
  contentProps?: React.ComponentProps<typeof Box>;
  /** Sets content area padding to 0 */
  flushLayout?: boolean;
  /** Element rendered inline after the title text (e.g. a beta badge) */
  rightTitleElement?: React.ReactNode;
  /** Left slot of the footer area */
  footerContent?: React.ReactNode;
  /** Right slot of the footer area */
  footerActions?: React.ReactNode;
}

type StaticContentBlockProps = ContentBlockBaseProps & {
  isCollapsible?: false;
  isOpen?: never;
  defaultOpen?: never;
  onOpenChange?: never;
};

export type CollapsibleContentBlockProps = ContentBlockBaseProps & {
  /** Enables collapse/expand behavior on the content area */
  isCollapsible: true;
  /** Controlled open state. When provided, the component is in controlled mode. */
  isOpen?: boolean;
  /** Initial open state for uncontrolled mode. Defaults to true. */
  defaultOpen?: boolean;
  /** Called when the open state changes */
  onOpenChange?: (open: boolean) => void;
};

export type ContentBlockProps =
  | StaticContentBlockProps
  | CollapsibleContentBlockProps;

/**
 * ContentBlock component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (used when
 * `contentProps` carries styled-system props), mirroring the Button hybrid.
 */
const ContentBlock = (props: ContentBlockProps) => (
  <ContentBlockHybrid {...props} />
);

export default ContentBlock;
